import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import trTranslations from './locales/tr.json';
import enTranslations from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: trTranslations },
      en: { translation: enTranslations },
      de: { translation: enTranslations },
      ar: { translation: enTranslations },
      ru: { translation: enTranslations }
    },
    fallbackLng: {
      de: ['en', 'tr'],
      ar: ['en', 'tr'],
      ru: ['en', 'tr'],
      default: ['tr']
    },
    lng: localStorage.getItem('language') || 'tr',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded added'
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
